import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import PolicyNav, { POLICY_UPDATED } from "./PolicyNav";
import "../css/privacy.scss";

export default function Cookies() {
  return (
    <main className="policy-page privacy">
      <header className="policy-hero policy-hero--legal">
        <p className="policy-eyebrow">Legal</p>
        <h1>Cookie policy</h1>
        <p>
          How {siteConfig.brandName} uses cookies, local storage, and similar
          browser technology.
        </p>
        <span>Effective {POLICY_UPDATED}</span>
      </header>

      <div className="policy-layout">
        <PolicyNav current="/cookies" />

        <article className="policy-content policy-content--legal">
          <section className="policy-intro" aria-labelledby="cookies-overview">
            <p className="policy-eyebrow">Browser technology</p>
            <h2 id="cookies-overview">Only what the storefront needs today.</h2>
            <p>
              This storefront currently uses essential browser storage for the
              features you request. It does not currently place advertising or
              optional analytics cookies. We will update this policy and add
              consent controls before introducing optional cookies where consent
              is legally required.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="cookies-meaning">
            <div className="policy-section__heading">
              <span>01</span>
              <h2 id="cookies-meaning">What these technologies are</h2>
            </div>
            <p>
              Cookies are small text records a website asks a browser to store.
              Local storage and session storage are similar browser features.
              Local storage can remain after the browser closes; session storage
              normally expires when the tab or session ends.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="cookies-current">
            <div className="policy-section__heading">
              <span>02</span>
              <h2 id="cookies-current">Storage used by this site</h2>
            </div>
            <div className="policy-table-wrap" tabIndex="0" role="region" aria-label="Browser storage purposes">
              <table>
                <caption className="sr-only">Essential browser storage used by the storefront</caption>
                <thead>
                  <tr>
                    <th scope="col">Purpose</th>
                    <th scope="col">Type</th>
                    <th scope="col">Typical duration</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Shopping bag</th>
                    <td>Local storage</td>
                    <td>Until cleared or replaced</td>
                  </tr>
                  <tr>
                    <th scope="row">Saved products</th>
                    <td>Local storage</td>
                    <td>Until cleared or replaced</td>
                  </tr>
                  <tr>
                    <th scope="row">Announcement preference</th>
                    <td>Local storage</td>
                    <td>Until cleared or replaced</td>
                  </tr>
                  <tr>
                    <th scope="row">Temporary order confirmation</th>
                    <td>Session storage</td>
                    <td>Current browser session</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="policy-section" aria-labelledby="cookies-providers">
            <div className="policy-section__heading">
              <span>03</span>
              <h2 id="cookies-providers">Service-provider technology</h2>
            </div>
            <p>
              Hosting, security, and hosted payment providers may use their own
              strictly necessary cookies or logs to deliver their services,
              prevent fraud, keep sessions secure, and complete payment. A page
              operated by another provider is also governed by that provider’s
              privacy and cookie information.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="cookies-controls">
            <div className="policy-section__heading">
              <span>04</span>
              <h2 id="cookies-controls">Your controls</h2>
            </div>
            <p>
              Browser settings let you inspect, block, or clear cookies and site
              data. Clearing local storage removes the bag, saved products, and
              stored preferences on that browser. Blocking essential storage can
              prevent those features from working. Because this site currently
              uses no advertising cookies, there is no advertising-cookie opt-out
              control to display.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="cookies-updates">
            <div className="policy-section__heading">
              <span>05</span>
              <h2 id="cookies-updates">Updates &amp; more information</h2>
            </div>
            <p>
              We may update this policy when our technology changes. Review our
              <Link to="/privacy"> Privacy Policy</Link> for more information
              about personal information and your rights.
            </p>
          </section>

          <section className="policy-help" aria-labelledby="cookies-help">
            <div>
              <p className="policy-eyebrow">Cookie questions</p>
              <h2 id="cookies-help">Ask us about browser storage.</h2>
            </div>
            <a href={`mailto:${siteConfig.contact.email}`}>
              {siteConfig.contact.email} <span aria-hidden="true">↗</span>
            </a>
          </section>
        </article>
      </div>
    </main>
  );
}
